import { Component, OnInit } from '@angular/core';
import { User } from '../../user.model';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  user!: User;

  constructor() { }

  ngOnInit(): void {
  }

  clickedOnUserList() {
    // Handle user selection from the list
    console.log('User selected:', this.user);
  }
} 